import React from 'react';
import { FormStateContext, FormStateProviderContextValue } from '..';

export const useFormState = <FormValuesT, >() =>
  React.useContext(FormStateContext) as FormStateProviderContextValue<FormValuesT>;
